import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import External from "./external.js"

import style from "./powered.module.css"

const Powered = () => (
	<StaticQuery
		query={graphql`
			query {
				powered: file(relativePath: { eq: "powered-disy.png" }) {
					childImageSharp {
						fixed(width: 92) {
							base64
							src
							srcSet
							height
							width
						}
					}
				}
			}
		`}
		render={data => (
			<div className={style.container}>
				<External to="https://www.disy.net/en/">
					<div>
						<Img
							className={style.powered}
							fixed={data.powered.childImageSharp.fixed}
						/>
					</div>
				</External>
			</div>
		)}
	/>
)
export default Powered
